import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const PolitiqueConfidentialite = () => {
    const lastUpdate = "9 septembre 2025";

    const sections = [
        {
            id: "donnees-collectees",
            title: "1. Données collectées",
            content: `
• Nom, prénom, raison sociale
• Adresse e-mail, numéro de téléphone
• Informations de facturation et de paiement
• Données relatives à la demande du client (devis, factures, informations comptables)
• Données de navigation (via cookies ou outils d’analyse type Google Analytics)
            `
        },
        {
            id: "finalites",
            title: "2. Finalités de la collecte",
            content: `
Les données sont collectées pour :
• Répondre aux demandes via le formulaire de contact
• Établir des devis, contrats et factures
• Gérer la relation client et le suivi comptable
• Améliorer le site internet et l’expérience utilisateur
• Envoyer, si accepté, des communications commerciales (newsletter, offres)
            `
        },
        {
            id: "base-legale",
            title: "3. Base légale du traitement",
            content: `
La collecte de données repose sur :
• L’exécution d’un contrat ou de mesures précontractuelles (demande de devis, facturation)
• Le respect d’obligations légales (obligations fiscales et comptables)
• Le consentement de l’utilisateur (cookies, newsletter)
            `
        },
        {
            id: "duree-conservation",
            title: "4. Durée de conservation",
            content: `
• Données clients : conservées pendant la durée de la relation contractuelle, puis archivées pendant 5 ans
• Données comptables et fiscales : conservées pendant 10 ans (obligation légale)
• Données prospects (devis non suivis) : conservées pendant 3 ans maximum
• Cookies : durée maximale de 13 mois
            `
        },
        {
            id: "partage",
            title: "5. Partage des données",
            content: `
Vos données sont strictement confidentielles et ne sont jamais vendues.
Elles peuvent être partagées uniquement avec :
• Les prestataires techniques (hébergeur IONOS, outils numériques sécurisés)
• Les administrations fiscales et sociales en cas d’obligation légale
            `
        },
        {
            id: "securite",
            title: "6. Sécurité des données",
            content: `
Gestion Freelance met en place des mesures techniques et organisationnelles pour protéger vos données 
(hébergement sécurisé, accès limité, mots de passe protégés)
            `
        },
        {
            id: "droits",
            title: "7. Droits des utilisateurs",
            content: `
Conformément au RGPD, vous disposez des droits suivants :
• Droit d’accès, de rectification, de suppression
• Droit à la limitation et à l’opposition du traitement
• Droit à la portabilité des données
• Droit de retirer votre consentement à tout moment (newsletter, cookies)

Vous pouvez exercer vos droits en écrivant à : contact@gestionfreelance.com.
En cas de litige, vous pouvez également saisir la CNIL (www.cnil.fr)
            `
        },
        {
            id: "cookies",
            title: "8. Cookies",
            content: `
Le site utilise des cookies pour améliorer la navigation et réaliser des statistiques.
Vous pouvez accepter ou refuser les cookies non essentiels via le bandeau affiché lors de votre première visite
            `
        },
    ];

    return (
        <>
            <Navbar />
            <main className="min-h-screen bg-white font-Poppins lg:pt-20 pt-10">
                <div className="mx-auto max-w-5xl px-4 sm:px-6 lg:px-8 py-12">
                    {/* En-tête */}
                    <header className="mb-12 text-start">
                        <h1 className="text-3xl sm:text-4xl font-bold lg:text-5xl tracking-tight text-color1 mb-3">
                            Politique de confidentialité (RGPD)
                        </h1>
                        <p className="text-sm sm:text-base text-gray-600 font-thin">
                            Dernière mise à jour : {lastUpdate}
                        </p >
                        <p className="text-sm sm:text-base text-gray-700 font-thin text-justify mt-4">
                            La société Gestion Freelance, SAS au siège social situé au 5 rue Gabriel Bourdarias,
                            69200 Vénissieux, s’engage à ce que la collecte et le traitement de vos données personnelles
                            soient conformes au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique
                            et Libertés.
                        </p>
                    </header>

                    {/* Sommaire */}
                    <nav
                        aria-label="Sommaire"
                        className="mb-10 rounded-2xl border border-color3 p-6 shadow-sm"
                    >
                        <h2 className="text-lg font-semibold text-color1 mb-4">Sommaire</h2>
                        <ul className="grid gap-3 sm:grid-cols-2">
                            {sections.map((s) => (
                                <li key={s.id}>
                                    <a
                                        href={`#${s.id}`}
                                        className="text-sm sm:text-base text-gray-700 hover:underline"
                                    >
                                        {s.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>

                    {/* Contenu */}
                    <div className="space-y-12">
                        {sections.map((s) => (
                            <section key={s.id} id={s.id}>
                                <h3 className="text-2xl sm:text-3xl font-bold text-color1 mb-4 text-start">
                                    {s.title}
                                </h3>
                                <p className="text-gray-700 text-base sm:text-lg leading-relaxed whitespace-pre-line">
                                    {s.content}
                                </p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
};

export default PolitiqueConfidentialite;
